var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionEquipment"}},[_c('Wrap',{staticClass:"lg"},[_c('h2',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t('headline'))+" ")]),_c('SubSectionInverters'),_c('SubSectionModules')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }